// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__32iyi","header":"MergedInvoice_header__4dCkS"};